import { render } from "./MicTalking.vue?vue&type=template&id=294d479a&scoped=true&ts=true"
import script from "./MicTalking.vue?vue&type=script&lang=ts"
export * from "./MicTalking.vue?vue&type=script&lang=ts"

import "./MicTalking.vue?vue&type=style&index=0&id=294d479a&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294d479a"]])

export default __exports__